import motion from "@/lib/lazy-motion-tags";
import { Droplets, Bug, Volume2, Wrench, Leaf } from "lucide-react";
import { Card } from "@/components/ui/card";

const FeaturesSection = () => {
  const features = [
    {
      icon: Droplets,
      title: "مقاومة تامة للماء",
      description: "عكس الخشب الطبيعي، لا تنتفخ أو تتشوه مع مرور الوقت. مثالية للمناطق الرطبة مثل الحمامات والمطابخ.",
      color: "text-blue-500",
    },
    {
      icon: Bug,
      title: "حماية كاملة ضد النمل الأبيض",
      description: "تركيبة WPC الفريدة تجعلها غير قابلة للتآكل من النمل الأبيض أو أي حشرات أخرى.",
      color: "text-amber-500",
    },
    {
      icon: Volume2,
      title: "عزل صوتي عالي الكفاءة",
      description: "توفر أبوابنا راحة تامة بفضل قدرتها الفائقة على امتصاص الضوضاء وتقليل الأصوات بين الغرف.",
      color: "text-purple-500",
    },
    {
      icon: Wrench,
      title: "لا تحتاج لصيانة متكررة",
      description: "أبوابنا تحتاج فقط لتنظيف بسيط دوري، ولا تحتاج للدهان أو الصيانة المكلفة.",
      color: "text-emerald-500",
    },
    {
      icon: Leaf,
      title: "صديقة للبيئة",
      description: "مصنوعة من مواد طبيعية معاد تدويرها، تساهم في تقليل البصمة الكربونية وحماية الغابات.",
      color: "text-green-600",
    },
  ];

  return (
    <section className="py-24 bg-card">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            لماذا تختار أبواب <span className="text-gradient">WPC</span>؟
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            الميزات الأساسية التي تجعل أبوابنا الخيار الأمثل لمنزلك أو مشروعك
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <Card className="p-8 hover-lift h-full border-2 hover:border-primary/50 transition-all">
                  <div className={`w-16 h-16 rounded-2xl bg-gradient-primary flex items-center justify-center mb-6 shadow-elegant`}>
                    <Icon className="h-8 w-8 text-accent" />
                  </div>
                  <h3 className="text-2xl font-bold mb-4">{feature.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
                </Card>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
